import { Tabs } from 'antd';
import { EnhancedSider } from 'components/page/index';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import Enums from 'utils/EnumsManager';
import { DataTypeIcon, Folders } from './index';

const { DASHBOARD_DATA_TYPES } = Enums.REPORTS;

const { TabPane } = Tabs;

const defaultProps = {};
const propTypes = {
  lang: PropTypes.string.isRequired
};

class Sider extends PureComponent {
  componentDidMount() {}

  render() {
    const TABS = ['0', '1'];

    return (
      <EnhancedSider style={{ padding: '10px' }} width={260}>
        <Tabs
          animated
          className="reportListTabs"
          defaultActiveKey={TABS[0]}
          tabBarGutter={0}
          type="card"
        >
          <TabPane
            key={TABS[0]}
            tab={<FormattedMessage id="page.DashboardSettings.tabs.dataType" />}
          >
            {DASHBOARD_DATA_TYPES.map((t, i) => (
              <DataTypeIcon
                key={i}
                iconType={t}
                isActive={i < 1}
                disabled={i > 0}
              />
            ))}
          </TabPane>
          <TabPane
            forceRender
            key={TABS[1]}
            tab={<FormattedMessage id="page.DashboardSettings.tabs.reports" />}
          >
            <Folders />
          </TabPane>
        </Tabs>
      </EnhancedSider>
    );
  }
}

const mapStateToProps = ({ global }) => ({
  lang: global.language
});
const mapDispatchToProps = {};
Sider.defaultProps = defaultProps;
Sider.propTypes = propTypes;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Sider);



// WEBPACK FOOTER //
// ./src/views/DashboardSettings/components/Sider.jsx